import type { StoredIntegrityFinding } from './integrityService';

/**
 * Archivierte Projekte in der Waechter-Ansicht ausblenden.
 *
 * „Archiv" heisst in der Anwendung `status = 'finished'` (es gibt keinen
 * eigenen Status; siehe AdminProjectList/AdminDashboard). Der Status steht je
 * nach Herkunft der Zeile in der Spalte ODER im JSON — beide Stellen lesen,
 * wie die Projektliste es tut.
 *
 * Ein Befund, dessen Projekt NICHT in der uebergebenen Liste steht, bleibt
 * SICHTBAR: die Liste ist firmengefiltert, und „unbekannt" darf nie wie
 * „archiviert" aussehen. Eine Zeile zu viel ist billiger als eine
 * verschwiegene Forderung.
 */
/**
 * Was der Filter von einer Projektzeile liest — mehr nicht. Bewusst eng und
 * ueberall optional: ein Listeneintrag (`ListProject`) passt hinein, ebenso
 * eine Zeile, die nur die Spalte ODER nur das JSON traegt.
 */
export interface ArchivPruefbaresProjekt {
    id?: string | null;
    status?: string | null;
    data?: { metadata?: { globalData?: { status?: string | null } | null } | null } | null;
}

export const istArchiviertesProjekt = (p: ArchivPruefbaresProjekt | null | undefined): boolean =>
    p?.status === 'finished' || p?.data?.metadata?.globalData?.status === 'finished';

export interface ArchivGefiltert {
    sichtbar: StoredIntegrityFinding[];
    /** Befunde, die wegen eines archivierten Projekts ausgeblendet wurden. */
    ausgeblendet: number;
}

export const ohneArchivierte = (
    findings: StoredIntegrityFinding[],
    projects: readonly ArchivPruefbaresProjekt[],
): ArchivGefiltert => {
    const archiviert = new Set<string>();
    projects.forEach((p) => { if (p?.id && istArchiviertesProjekt(p)) archiviert.add(p.id); });
    const sichtbar = findings.filter((f) => !archiviert.has(f.projectId));
    return { sichtbar, ausgeblendet: findings.length - sichtbar.length };
};
